<template>
  <div>
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />

    <div v-if="showRealStatesGraphic" class="graphic-space">
      <apexchart type="bar" :height="tamImob" :options="imobChartOptions" :series="imobData"></apexchart>
    </div>
  </div>
</template>
<script>

import apexchart from 'vue-apexcharts'
import DialogLoading from '@/components/loading/DialogLoading'
import message from '@/utils/message'
import RecordsClients from './RecordsClients.vue'
import RecordsReserves from './RecordsReserves.vue'
import api from '@/services/api'

export default {
  components: {
    apexchart: apexchart,
    DialogLoading,
    RecordsClients,
    RecordsReserves
  },

  computed: {
    tamImob () {
      return this.imobData.length > 0 ? this.imobData[0].data.length * 70 : 250
    }
  },
  data: () => ({
    showRealStatesGraphic: false,
    loading: true,
    loadingMessage: 'Carregando',
    imobData: [
      {
        name: 'Clientes',
        data: []
      },
      {
        name: 'Reservas',
        data: []
      }
    ],
    imobChartOptions: {
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      title: {
        text: 'Cadastros por imobiliária',
        align: 'left'
      },
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      tooltip: {
        shared: true,
        intersect: false
      },
      xaxis: {
        categories: []
      }
    }
  }),
  created () {
    this.getRealStatesInfos()
  },

  methods: {
    async getRealStatesInfos () {
      try {
        this.loading = true
        const { data } = await api.get('/real-states-infos')
        data.forEach(info => {
          this.imobChartOptions.xaxis.categories.push(info.name)
          this.imobData[0].data.push(info.total_clients)
          this.imobData[1].data.push(info.total_reserves)
        })
        this.showRealStatesGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico das imobiliárias')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
  .graphic-imob-container {
    max-height: 250;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboards/RealStates.vue